import React from "react";
import cn from "classnames";
import { buttonVariants } from "theme/buttonVariants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleLandscape } from "@fortawesome/pro-regular-svg-icons/faRectangleLandscape";

const ImageAndTextComponent = ({
    state: { items = [], selectedItemIndex },
    isEditMode,
    onChange,
    focused,
}) => {
    if (items.length === 0) {
        return (
            <div className="flex py-10 justify-center items-center w-full">
                <FontAwesomeIcon icon={faRectangleLandscape} size="6x" />
            </div>
        );
    }

    return (
        <div className="flex flex-col lg:flex-row gap-[15px] lg:gap-[30px]">
            {items.map((item, index) => {
                const {
                    imageAndTextHeading,
                    headingColour,
                    imageAndTextSubHeading,
                    imageAndTextButtonLink,
                    imageAndTextButtonText,
                    imageAndTextButtonColour,
                    url,
                    mobileUrl,
                    mobileImagePosition,
                } = item;
                return (
                    <div
                        key={`image-and-text-${index}`}
                        className="relative flex flex-grow flex-1 flex-col lg:items-start justify-start lg:justify-center p-[30px] rounded-[10px] aspect-[335/200] sm:aspect-[645/300]"
                        style={{
                            backgroundColor: "#ddd",
                            boxShadow:
                                selectedItemIndex === index &&
                                focused &&
                                "0 0 0 3px red",
                        }}
                        onClick={(e) => {
                            if (isEditMode) {
                                e.preventDefault();
                                onChange({
                                    selectedItemIndex: index,
                                });
                            }
                        }}
                    >
                        <div className="flex flex-col gap-[30px] z-10 items-start max-w-[50%] w-full">
                            <div className="flex flex-col">
                                {imageAndTextHeading && (
                                    <h2
                                        className={cn(
                                            `!text-[18px] !leading-[24px] lg:!text-[30px] lg:!leading-[36px] uppercase mb-0`,
                                            headingColour,
                                        )}
                                    >
                                        {imageAndTextHeading}
                                    </h2>
                                )}

                                {imageAndTextSubHeading && (
                                    <h2
                                        className={cn(
                                            `!text-[18px] !leading-[24px] lg:!text-[30px] lg:!leading-[36px] mb-0`,
                                            headingColour,
                                        )}
                                    >
                                        {imageAndTextSubHeading}
                                    </h2>
                                )}
                            </div>

                            {imageAndTextButtonLink && (
                                <a
                                    type="button"
                                    href={imageAndTextButtonLink}
                                    className={cn(
                                        buttonVariants[imageAndTextButtonColour]
                                            .solidClasses,
                                        "!text-brand-white !no-underline hover:text-brand-white !hover:font-bold !border-transparent !font-bold mt-[15px]",
                                    )}
                                >
                                    {imageAndTextButtonText}
                                </a>
                            )}
                        </div>

                        {url && (
                            <img
                                src={url}
                                className={cn(
                                    "absolute top-0 left-0 w-full h-full object-cover rounded-[10px]",
                                    {
                                        "hidden lg:block": !!mobileUrl,
                                        "object-left lg:object-center":
                                            mobileImagePosition === "left",
                                        "object-center":
                                            mobileImagePosition === "center",
                                        "object-right lg:object-center":
                                            mobileImagePosition === "right",
                                    },
                                )}
                                alt="Background"
                            />
                        )}

                        {mobileUrl && (
                            <img
                                src={mobileUrl}
                                className={cn(
                                    "absolute top-0 left-0 w-full h-full object-cover rounded-[10px] block lg:hidden",
                                    {
                                        "object-left lg:object-center":
                                            mobileImagePosition === "left",
                                        "object-center":
                                            mobileImagePosition === "center",
                                        "object-right lg:object-center":
                                            mobileImagePosition === "right",
                                    },
                                )}
                                alt="Background"
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default ImageAndTextComponent;
